module.exports = __webpack_public_path__ + "img/login3.384ef203.jpg";